import { Action, createReducer, on } from '@ngrx/store';
import { State } from 'src/app/+state/reducers';
import { ApplicationSearchState } from 'src/app/applications/application-filter-form/application-filter-form.component';
import { HiveApplication } from 'src/app/applications/hive-application';
import * as ApplicationsActions from './applications.actions';

export const applicationFeatureKey = 'applications';

export interface AppState extends State {
  [applicationFeatureKey]: ApplicationsState;
}

export interface ApplicationsState {
  applications: HiveApplication[];
  itemUsesTableFilter: ApplicationSearchState;
}

const initialState = {
  itemUsesTableFilter: {}
} as ApplicationsState;

const applicationsReducer = createReducer(
  initialState,
  on(ApplicationsActions.getHiveApplicationsSuccess, (state, {applications}) => ({
    ...state,
    applications
  })),
  on(ApplicationsActions.updateItemUsesTableFilter, (state, {tableFilter}) => ({
    ...state,
    itemUsesTableFilter: tableFilter
  }))
);

export function reducer(state: ApplicationsState | undefined, action: Action) {
  return applicationsReducer(state, action);
}
